import { Instance, types } from "mobx-state-tree";

export const SavedPrompt = types.model("savedPrompt", {
    title: types.string,
    prompt: types.string,
    copilot: types.string,
    plugin: types.string
});

export type SavedPromptInstance = Instance<typeof SavedPrompt>;
